<style lang="scss" src='./SensorAlerts.scss' scoped></style>
<template src="./SensorAlerts.html"></template>

<script>
import AlertItem from "@/views/alerts/item/AlertItem.vue";
import VuePullRefresh from "vue-pull-refresh";
import { GetAlertBySensor } from "@/api/api";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

export default {
  name: "SensorAlerts",
  components: {
    AlertItem,
    "vue-pull-refresh": VuePullRefresh,
  },
  props: {
    sensor: {
      required: true,
    },
  },
  data() {
    return {
      sensorAlerts: {},
      alertTypeArray: [],
      maxHeightAlert: 600,
    };
  },

  computed: {
    ...mapState("AlertList", {
      alertStatusFilter: (state) => state.alertStatusFilter,
      loading: (state) => state.loading,
    }),
    ...mapGetters("AlertList", ["sensorAlertsFiltered"]),
  },

  watch: {},

  methods: {
    refreshAlertList() {
      const self = this;
      // eslint-disable-next-line
      return new Promise(async function (resolve, reject) {
        await self.loadData();
        resolve("ok");
      });
    },

    async loadData() {
      const selectArray = [
        this.consts.AlertType.DIELECTRIC,
        this.consts.AlertType.GROUND_TEMPERATURE,
        this.consts.AlertType.MOISTURE,
        this.consts.AlertType.SALINITY
      ];

      if(this.isAdminOrOpsUser()){
        selectArray.push(this.consts.AlertType.COMMUNICATION_FAILURE);
        selectArray.push(this.consts.AlertType.SENSOR_TRANSITION);
      }

      this.alertTypeArray = [...selectArray];

      this.sensorAlerts = await GetAlertBySensor(this.sensor.sensor_id);
      this.setSensorAlerts(this.sensorAlerts.alerts);
    },

    isAdminOrOpsUser(){
      if (this.$store.state.user.user_type.type_id == this.consts.UserType.ADMIN ||
            this.$store.state.user.user_type.type_id == this.consts.UserType.OPERATIONS){
          return true;
      }
      return false;
    },

    async selectAlert(alert) {
      if (alert) {
        this.alertSelected = alert;
        this.$store.commit("setAlert", alert);
        this.$router.push("/alerts-details");
      }
    },

    adjustAlertListHeight() {
      const self = this;
      // eslint-disable-next-line
      const alertHeightInterval = setInterval(function () {
        if (self.$refs.alertsContainer) {
          self.maxHeightAlert =
            window.innerHeight -
            80 -
            self.$refs.alertsContainer.getBoundingClientRect().top;
        }
      }, 1000);
      // eslint-disable-next-line
      setTimeout(function () {
        clearInterval(alertHeightInterval);
      }, 5000);
    },

    ...mapActions("AlertList", ["loadAlerts"]),

    ...mapMutations("AlertList", [
      "setLoading",
      "setAlertStatusFilter",
      "resetAlertStatusFilter",
      "setSensorAlerts",
    ]),
  },

  beforeCreate() {},

  created() {},

  beforeMount() {
    this.resetAlertStatusFilter();
  },

  mounted() {
    this.adjustAlertListHeight();
    this.loadData();
  },

  beforeDestroy() {},
};
</script>
